<template>
  <PageWrapper>
    <MasterAbsenceReportsForAdmin></MasterAbsenceReportsForAdmin>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      absenceReports: null,
      absenceReportsListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        masterUserId: null,
      },
    };
  },
  methods: {
    async getAllAbsenceReportList() {},
  },
  components: {
    PageWrapper,
    SearchInput,
    CustomTable,
    MasterAbsenceReportsForAdmin,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import MasterAbsenceReportsForAdmin from "@/views/components/Schedule/MasterAbsenceReportsForAdmin.vue";
</script>
